import { toast } from "react-toastify";
import { apiSlice } from "../api/apiSlice";

export const leavePolicyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLeavePolicies: builder.query({
      query: () => ({
        url: `leave-policy?query=all`,
      }),
      providesTags: ["LeavePolicies"],
    }),

    getLeavePolicy: builder.query({
      query: (id) => ({
        url: `leave-policy/${id}`,
      }),
      providesTags: ["LeavePolicy"],
    }),

    addLeavePolicy: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `leave-policy/`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;

          toast.success("LeavePolicys added successfully");
        } catch (err) {
          toast.error("An error occurred while adding LeavePolicys");
        }
      },
      invalidatesTags: ["LeavePolicies"],
    }),

    updateLeavePolicy: builder.mutation({
      query: ({ id, values }) => ({
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `leave-policy/${id}`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;

          toast.success("LeavePolicys updated successfully");
        } catch (err) {
          toast.error("An error occurred while updating LeavePolicys");
        }
      },
      invalidatesTags: ["LeavePolicies", "LeavePolicy"],
    }),

    deleteLeavePolicy: builder.mutation({
      query: (id) => ({
        url: `leave-policy/${id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: {
          status: false,
        },
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;

          toast.success("Deleted LeavePolicys successful");
        } catch (err) {
          toast.error("An error occurred while deleting the LeavePolicys");
        }
      },
      invalidatesTags: ["LeavePolicies", "LeavePolicy"],
    }),
  }),
});

export const {
  useGetLeavePoliciesQuery,
  useGetLeavePolicyQuery,
  useAddLeavePolicyMutation,
  useUpdateLeavePolicyMutation,
  useDeleteLeavePolicyMutation,
} = leavePolicyApi;
